import { Link } from "react-router-dom";
import { handleLogout } from './AuthUtils';
import { getUserRole, isAuthenticated } from '../utils/auth';

const Logout = () => {
  const user = getUserRole();
  const isLoggedIn = isAuthenticated();
  const onButtonClick = () => {
    handleLogout();
  };


  return (
    <>
      <div className="my-3">
        <div className="text-md mt-2 mb-2">Name: {user?.name || 'Guest'}</div>
        <div className="text-md mt-2 mb-2">Email: {user?.email || 'guest@gmail.com'}</div>
        {isLoggedIn ?
          <Link to="#" className="text-md text-blue-500 hover:underline" onClick={onButtonClick}>Logout</Link>
          : ""}
      </div>
    </>
  )
}

export default Logout